/**
 * Which Stream Chat app this build talks to — not Node/Vercel `NODE_ENV`.
 * Localhost can (and often does) use the production Stream app.
 *
 * Values: `production` | `staging` | `development`
 * Set `GATSBY_STREAM_ENVIRONMENT` next to the Stream key, or let Gatsby
 * detect it from Stream `getAppSettings()` at bootstrap.
 */

export function normalizeStreamChatEnvironment(raw) {
  const value = String(raw || '').trim().toLowerCase()
  if (value === 'production' || value === 'prod' || value === 'live') {
    return 'production'
  }
  if (value === 'staging' || value === 'stage' || value === 'beta') {
    return 'staging'
  }
  if (value === 'development' || value === 'dev') {
    return 'development'
  }
  return null
}

export function streamChatEnvironment() {
  return (
    normalizeStreamChatEnvironment(process.env.GATSBY_STREAM_ENVIRONMENT) ||
    'production'
  )
}

/** Brand tennis-ball green. Staging/development Stream apps use blueprint blue. */
export function isProductionStreamChat() {
  return streamChatEnvironment() === 'production'
}

export function streamChatEnvironmentLabel() {
  const environment = streamChatEnvironment()
  if (environment === 'staging') return 'Staging'
  if (environment === 'development') return 'Development'
  return 'Production'
}
